import { getRepository } from './repository';

const resource = "/product";

export default {
    getProductDetails(headers) {
        return getRepository().get(`${resource}/details`, { headers : headers })
    },
    getAvailableOptions(headers, params) {
        return getRepository().get(`${resource}/availableOptions?setup=${params}`, { headers : headers })
    },
    getEditorValues(headers, params) {
        return getRepository().get(`${resource}/editorValues?setup=${params}`, { headers : headers })
    },
    getPrice(headers, params) {
        return getRepository().get(`${resource}/price?setup=${params}`, { headers : headers })
    }
};